module.exports = __webpack_public_path__ + "static/media/dapps.9d2bece1.png";